// i18n
import { StartWeekDay } from 'domains/models/event_type/startWeekDay';
import { DateTime } from 'infras/datetime';
import { TimeZoneListItem } from 'presentations/api/schema/time_zone';
import { SyntheticEvent, useMemo, useRef } from 'react';

interface Props {
  selectedDate: DateTime | null;
  defaultDate?: DateTime | null;
  onDateSelect?: any;
  onTimeZoneSelect?: any;
  timeZones: TimeZoneListItem[];
  timeZone: string | null;
  isLoading?: boolean;
  onChangeMonth?: any;
  availableDays: boolean[] | null;
  isOpen: boolean;
  color: string;
  isLightColor: boolean;
  isHostDiagnosticMode?: boolean;
  startWeekDay: StartWeekDay;
  isFetching: boolean;
}

export const useEventTypeDateForm = (props: Props) => {
  const datePickerRef = useRef<HTMLDivElement>(null);

  const isAvailable = useMemo(() => {
    if (props.availableDays && props.availableDays.length > 0) {
      if (props.isHostDiagnosticMode) return true;
      const availableDays = props.availableDays.filter(
        (isAvailable) => isAvailable === true,
      );
      if (availableDays.length > 0) return true;
    }
    return false;
  }, [props.availableDays, props.isHostDiagnosticMode]);

  function shouldDisableDate(dateTime: DateTime): boolean {
    if (props.isHostDiagnosticMode) return false;
    if (!props.availableDays) return false;
    const index = dateTime.day - 1;
    return !props.availableDays[index];
  }

  const onClickCalendarUnavailableButton = (e: SyntheticEvent<any>) => {
    e.preventDefault();
    e.stopPropagation();

    let nextMonthButton: any;
    if (window && window.document) {
      const buttons = Array.from(
        window.document
          .getElementsByClassName('MuiPickersArrowSwitcher-root')[0]
          .getElementsByTagName('button'),
      );
      if (buttons && buttons.length === 2) {
        nextMonthButton = buttons[1];
      }
    }
    if (nextMonthButton) {
      (nextMonthButton as HTMLElement).click();
    }
  };

  let unavailableButtonTopPos = 0;
  if (datePickerRef.current) {
    const pickerView = datePickerRef.current.getElementsByClassName(
      'MuiCalendarPicker-root',
    );
    if (pickerView && pickerView.length > 0) {
      const pickerViewChildren = pickerView[0].children;

      if (pickerViewChildren && pickerViewChildren.length === 2) {
        const calendarHead: any = pickerViewChildren[0];
        const calendarBody: any = pickerViewChildren[1];
        const unavailableButtonHeight = 164;
        unavailableButtonTopPos =
          (calendarBody.offsetHeight - unavailableButtonHeight) / 2 +
          calendarHead.offsetHeight;
      }
    }
  }

  return {
    state: {
      datePickerRef,
      isAvailable,
      unavailableButtonTopPos,
    },
    actions: {
      onClickCalendarUnavailableButton,
      shouldDisableDate,
    },
  };
};
